import { getConfigFor } from './helpers/getConfigFor';

// Bloomreach URLs
export const bloomreachUrl = getConfigFor.environment<string>({
	local: 'https://test.kvk-dop.bloomreach.cloud/',
	tst: 'https://test.kvk-dop.bloomreach.cloud/',
	acp: 'https://acceptance.kvk-dop.bloomreach.cloud/',
	staging: 'https://production.kvk-dop.bloomreach.cloud/',
	prd: 'https://production.kvk-dop.bloomreach.cloud/',
});
